var map = {
	"./dot.svg": "d5fb",
	"./hands.svg": "0f85",
	"./section1-1-desktop.png": "358f",
	"./section1-1-mobile.png": "d506",
	"./section1-2-mobile.png": "2065",
	"./section2-1-desktop.png": "ed7a",
	"./section2-1-mobile.png": "46a5",
	"./section2-2-mobile.png": "9706",
	"./section3-1-desktop.png": "a901",
	"./section3-1-mobile.png": "b36a",
	"./section4-1-desktop.png": "884b",
	"./section4-1-mobile.png": "e30a",
	"./section4-2-desktop.png": "a67b",
	"./section4-2-mobile.png": "88e2",
	"./section4-3-desktop.png": "968a",
	"./section4-3-mobile.png": "2567",
	"./section4-4-desktop.png": "1f70",
	"./section5-1-desktop.png": "5db2",
	"./section5-1-mobile.png": "ca4f",
	"./section6-1-desktop.png": "9123",
	"./section6-1-mobile.png": "76ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f92";